import React from 'react';
import LeadScraperShared from '../Shared/LeadScraperShared';
import MainLayout from '../../../components/layout/MainLayout';

const LeadScraperManager = () => {
  return (
    <MainLayout title="Lead Scraper">
      <div style={{ padding: '24px' }}>
        <LeadScraperShared showSettings={false} />
      </div>
    </MainLayout>
  );
};

export default LeadScraperManager;
